var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49219 1.21094L4.70312 4L7.49219 6.78906L6.78906 7.49219L4 4.70312L1.21094 7.49219L0.507812 6.78906L3.29688 4L0.507812 1.21094L1.21094 0.507812L4 3.29688L6.78906 0.507812L7.49219 1.21094Z",
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/close-dark.e50ee130ab9a54b4da716394131376dc.svg";
export { ForwardRef as ReactComponent };